module.exports = __webpack_public_path__ + "img/logo-alt.2d854787.svg";